import { htmlSafe } from "@ember/template";
import { classNames } from "@ember-decorators/component";
import discourseComputed from "discourse/lib/decorators";
import SelectedNameComponent from "select-kit/components/selected-name";
const SelectedColor = dt7948.c(class SelectedColor extends SelectedNameComponent {
  footerContent(name) {
    return htmlSafe(`<span class="color-preview" style="background:#${name}"></span>`);
  }
  static {
    dt7948.n(this.prototype, "footerContent", [discourseComputed("name")]);
  }
}, [classNames("select-kit-selected-color")]);
export default SelectedColor;